import { render, staticRenderFns } from "./AerztePage.vue?vue&type=template&id=b4291076&"
import script from "./AerztePage.vue?vue&type=script&lang=js&"
export * from "./AerztePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports